module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB5#ch3"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Abingdon New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek–English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(", ed. W. Bauer, F. W. Danker, W. F. Arndt and F. W. Gingrich, 3rd edn (Chicago: University of Chicago Press, 2000)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BECNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Black’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ChrCent")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Century")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Criswell Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DNTB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary of New Testament Background")]), _vm._v(", ed. Craig A. Evans and Stanley E. Porter (Downers Grove: InterVarsity Press, 2000)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DPL")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary of Paul and His Letters")]), _vm._v(", 2nd edn (Downers Grove: InterVarsity Press, forthcoming)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Encyclopedia of the Bible and Its Reception")]), _vm._v(", ed. Hans-Josef Klauck et al. (Berlin: Walter de Gruyter, 2009)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ExAud")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ex Auditu")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("L&N")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek–English Lexicon of the New Testament: Based on Semantic Domains")]), _vm._v(", ed. Johannes P. Louw and Eugene A. Nida, 2nd edn (New York: United Bible Societies, 1989)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("LXX")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Septuagint (pre-Christian Greek version of the Old Testament)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("MM")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vocabulary of the Greek Testament Illustrated from the Papyri and Other Non-Literary Sources")]), _vm._v(", ed. J. H. Moulton and G. Milligan (Grand Rapids: Eerdmans, 1930–82)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Interpreter’s Bible")]), _vm._v(", ed. Leander E. Keck, 12 vols. (Nashville: Abingdon, 1994–2004)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NIGTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NovTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SBLGNT")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Greek New Testament: SBL Edition")]), _vm._v(", ed. Michael W. Holmes (Atlanta: SBL, 2010)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SNTSMS")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Society for New Testament Studies Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Sacra Pagina")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TLNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theological Lexicon of the New Testament")]), _vm._v(", C. Spicq, tr. and ed. J. D. Ernest (Peabody: Hendrickson, 1994)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Tyndale New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "ahd1"
  }, [_c('strong', [_vm._v("Bible versions")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CEB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Common English Bible. © Copyright 2011 by the Common English Bible. All rights reserved. Used by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CJB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Complete Jewish Bible. Copyright © 1998 by David H. Stern.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("CSB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Christian Standard Bible. Copyright © 2017 by Holman Bible Publishers. Used by permission. Christian Standard Bible®, and CSB® are federally registered trademarks of Holman Bible Publishers, all rights reserved. ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ESV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The ESV Bible (The Holy Bible, English Standard Version), copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("GNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Good News Bible, The Bible in Today’s English Version. New Testament © 1966, 1971, 1976 by the American Bible Society.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("GNV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("Geneva Bible, 1599 Edition. Published by Tolle Lege Press. "), _c('a', {
    staticClass: "www",
    attrs: {
      "href": "http://www.GenevaBible.com",
      "target": "_blank"
    }
  }, [_vm._v("GenevaBible.com")]), _vm._v(" All rights reserved. ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ISV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Holy Bible: International Standard Version®. Copyright © 1996–2007 by The ISV Foundation of Fullerton, California, USA. Used by permission of Davidson Press, LLC. ALL RIGHTS RESERVED INTERNATIONALLY.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NASB")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The NEW AMERICAN STANDARD BIBLE®, Copyright © 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation. Used by permission.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NET")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The NET Bible, New English Translation, copyright © 1996 by Biblical Studies Press, LLC. NET Bible is a registered trademark.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NIV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The Holy Bible, New International Version (Anglicized edition). Copyright © 1979, 1984, 2011 by Biblica. Used by permission of Hodder & Stoughton Ltd, an Hachette UK company. All rights reserved. ‘"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("NIV")]), _vm._v("’ is a registered trademark of Biblica. UK trademark number 1448790.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NLT")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Holy Bible")]), _vm._v(", New Living Translation, copyright © 1996. Used by permission of Tyndale House Publishers, Inc., Carol Stream, Illinois 60189, USA. All rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("NRSV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The New Revised Standard Version of the Bible, Anglicized Edition, copyright © 1989, 1995 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("TNIV")])])]), _vm._v(" "), _c('td', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "abb_fo1"
  }, [_vm._v("The HOLY BIBLE, TODAY’S NEW INTERNATIONAL VERSION. Copyright © 2004 by International Bible Society. Used by permission of Hodder & Stoughton Publishers, a member of the Hachette UK Group. All rights reserved. ‘TNIV’ is a registered trademark of International Bible Society.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f90e3d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781789742671_EPUB8.vue
// module id = 75
// module chunks = 0